<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">

    <div class="contents-wrapper">

      <div class="main-contents">

        <detail-row-component title="아로마 이름" :inner-vertical="true">

          <layout-input v-model="editable.name"
                        placeHolder="한글 이름을 입력해주세요."
                        :regex="regex(2, 100).ko_num"/>

          <layout-input v-model="editable.code"
                        placeHolder="영문 이름을 입력해주세요."
                        :regex="regex(2, 100).en_num"/>

        </detail-row-component>

        <detail-row-component title="아로마 이미지" innerVertical>

          <layout-image-selecotr v-model="editable.img"
                                 :index="`image_aroma${rowData.id}`"
                                 :on-image-out-of-size="onImageOutOfSize"/>
          <layout-info title="* 아로마 이미지 사이즈 : 180 X 300" infoType="warn"/>

        </detail-row-component>

        <detail-row-component title="발행">

          <layout-switch-button v-model="editable.isChecked"/>

        </detail-row-component>

      </div>

    </div>

  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from '@/utils/utils';

import DetailRowWrapper from '@/spa/components/detail-row/DetailRowWrapper';
import DetailRowComponent from '@/spa/components/detail-row/DetailRowComponent';

import LayoutInput from '@/spa/components/LayoutInput';
import LayoutSwitchButton from '@/spa/components/LayoutSwitchButton';
import LayoutImageSelecotr from '@/spa/components/LayoutImageSelector';
import LayoutInfo from '@/spa/components/LayoutInfo';

export default {
  name: 'AromaEditor',
  components: {
    LayoutInput,
    LayoutSwitchButton,
    LayoutImageSelecotr,
    DetailRowWrapper,
    DetailRowComponent,
    LayoutInfo,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onImageOutOfSize() {
      this.$toast('사이즈가 4메가가 넘습니다.');
    },

    regex(min, max) {
      return regex(min, max);
    },

    async uploadImage(image) {
      if (!image) return null;
      if (typeof image === 'string') return image;

      const result = await this.$store.dispatch('imageUploadS3', { name: 'aroma', image });

      if (!result.response) return image;
      this.$toast(result.message);
      this.$toast('데이터베이스 업로드 작업중 입니다. 조금만 기다려주세요.');

      return result.response.location;
    },

    async submit() {
      this.editable.id = this.rowData.id;
      this.editable.img = await this.uploadImage(this.editable.img);

      const validateResult = multipleValidate([
        validate({ message: '한글 이름', target: this.editable.name, regex: regex(2, 100).ko_num }),
        validate({ message: '영어 이름', target: this.editable.code, regex: regex(2, 100).en_num }),
      ]);

      if (this.editable.isChecked && validateResult.flag) {
        this.$toast(validateResult.message);
        return;
      }

      const result = await this.$store.dispatch('updateAroma', this.editable);

      if (result.response) {
        this.$table.updateField();
      }

      this.$toast(result.message);
    },

    cancel() {
      this.$table.updateField();
    },
  },
  data() {
    return {
      editable: {
        code: this.rowData.code,
        name: this.rowData.name,
        img: this.rowData.img,
        isChecked: this.rowData.is_checked,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: auto;

  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  flex-direction: row;

  .main-contents {
    position: relative;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;

    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/aroma/detail-row/AromaEditor.vue